export default "__VITE_ASSET__DOc8G8NE__"